var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
    },
    [
      _vm.recordList.length > 0
        ? _c(
            "div",
            [
              _c(
                "el-timeline",
                _vm._l(_vm.recordList, function (item, index) {
                  return _c(
                    "el-timeline-item",
                    {
                      key: index,
                      attrs: {
                        timestamp:
                          item.step +
                          (item.createBy ? "     " + item.createBy : "") +
                          "                    " +
                          item.createTime,
                        color: _vm.getTimelineColor(item.action),
                        placement: "top",
                      },
                    },
                    [
                      _c(
                        "el-card",
                        { attrs: { shadow: "hover", size: "small" } },
                        [
                          item.remark
                            ? _c("div", { staticClass: "log-info-item" }, [
                                _c(
                                  "span",
                                  {
                                    staticClass: "log-info-value",
                                    staticStyle: {
                                      "font-size": "16px",
                                      "font-weight": "bold",
                                    },
                                  },
                                  [_vm._v(_vm._s(item.remark))]
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", { staticClass: "log-content" }, [
                            _vm._v(_vm._s(item.content)),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "log-info-grid" }, [
                            item.quantity !== null &&
                            item.quantity !== undefined
                              ? _c("div", { staticClass: "log-info-item" }, [
                                  _c(
                                    "span",
                                    { staticClass: "log-info-label" },
                                    [_vm._v("数量：")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "log-info-value" },
                                    [_vm._v(_vm._s(item.quantity))]
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            item.coordinateAddress
                              ? _c("div", { staticClass: "log-info-item" }, [
                                  _c(
                                    "span",
                                    { staticClass: "log-info-label" },
                                    [_vm._v("坐标地址：")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "log-info-value" },
                                    [_vm._v(_vm._s(item.coordinateAddress))]
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            item.coordinateX !== null &&
                            item.coordinateX !== undefined
                              ? _c("div", { staticClass: "log-info-item" }, [
                                  _c(
                                    "span",
                                    { staticClass: "log-info-label" },
                                    [_vm._v("坐标：")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "log-info-value" },
                                    [
                                      _vm._v(
                                        _vm._s(item.coordinateX) +
                                          ", " +
                                          _vm._s(item.coordinateY)
                                      ),
                                    ]
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            item.photo
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "log-info-item log-info-full",
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "log-photo-list" },
                                      _vm._l(
                                        _vm.getPhotoList(item.photo),
                                        function (url, idx) {
                                          return _c("el-image", {
                                            key: idx,
                                            staticStyle: {
                                              width: "80px",
                                              height: "80px",
                                              margin: "10px",
                                            },
                                            attrs: {
                                              src: url,
                                              "preview-src-list":
                                                _vm.getPhotoList(item.photo),
                                              "initial-index": idx,
                                              fit: "cover",
                                            },
                                          })
                                        }
                                      ),
                                      1
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            item.video
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "log-info-item log-info-full",
                                  },
                                  [
                                    _c(
                                      "video",
                                      {
                                        staticStyle: {
                                          width: "80px",
                                          height: "80px",
                                          margin: "10px",
                                          background: "#000",
                                        },
                                        attrs: {
                                          src: item.video,
                                          controls: "",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                您的浏览器不支持视频播放\n              "
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]),
                        ]
                      ),
                    ],
                    1
                  )
                }),
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "pagination" },
                [
                  _vm.total > 0
                    ? _c("el-pagination", {
                        attrs: {
                          layout: "prev, pager, next",
                          total: _vm.total,
                          "page-size": _vm.pageSize,
                          "current-page": _vm.currentPage,
                          small: "",
                          background: "",
                        },
                        on: {
                          "update:currentPage": function ($event) {
                            _vm.currentPage = $event
                          },
                          "update:current-page": function ($event) {
                            _vm.currentPage = $event
                          },
                          "current-change": _vm.handlePageChange,
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          )
        : !_vm.loading
        ? _c(
            "div",
            {
              staticStyle: {
                "text-align": "center",
                padding: "40px",
                color: "#909399",
              },
            },
            [_vm._v("\n    暂无操作记录\n  ")]
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }